// extracted by mini-css-extract-plugin
export var banner = "GlobalBanner-module--banner--a6a87";
export var bannerAppear = "GlobalBanner-module--bannerAppear--57762";
export var bannerNudge = "GlobalBanner-module--bannerNudge--9458d";
export var bannerPulse = "GlobalBanner-module--bannerPulse--494b2";
export var bannerShimmer = "GlobalBanner-module--bannerShimmer--c3d82";
export var bold = "GlobalBanner-module--bold--a92d1";
export var close = "GlobalBanner-module--close--57206";
export var closeIcon = "GlobalBanner-module--closeIcon--2fe1c";
export var cta = "GlobalBanner-module--cta--e5a30";
export var ctaIcon = "GlobalBanner-module--ctaIcon--e78c0";
export var icon = "GlobalBanner-module--icon--51540";
export var iconBadge = "GlobalBanner-module--iconBadge--d4240";
export var info = "GlobalBanner-module--info--c6fb2";
export var inlineLink = "GlobalBanner-module--inlineLink--7dc9a";
export var inner = "GlobalBanner-module--inner--ecf6b";
export var message = "GlobalBanner-module--message--9d472";
export var promo = "GlobalBanner-module--promo--72e08";
export var success = "GlobalBanner-module--success--57943";
export var warning = "GlobalBanner-module--warning--4b886";